function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { SmartNav } from 'module-tsl-ui-smart-nav';

var ElementsFiltersMobile = /*#__PURE__*/function (_React$Component) {
  _inherits(ElementsFiltersMobile, _React$Component);

  var _super = _createSuper(ElementsFiltersMobile);

  function ElementsFiltersMobile(props) {
    var _this;

    _classCallCheck(this, ElementsFiltersMobile);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getMenu", function (resourceTypes, ageGroups) {
      var emptyMenu = [];

      var menuWithResourceTypes = _this.fillMenuWithResourceType(resourceTypes, emptyMenu);

      var menu = _this.fillMenuWithAgeGroups(ageGroups, menuWithResourceTypes);

      return menu;
    });

    _defineProperty(_assertThisInitialized(_this), "getNewValues", function (checkedItems, label) {
      return checkedItems.filter(function (_ref) {
        var ancestors = _ref.ancestors;
        return ancestors[0].label === label;
      }).map(function (_ref2) {
        var transformedName = _ref2.transformedName;
        return transformedName;
      }).join();
    });

    _defineProperty(_assertThisInitialized(_this), "updateUrl", function (currentUrl, key, newValue) {
      var newValueString = !newValue ? '' : "&".concat(key, "=").concat(newValue);
      return currentUrl.replace(new RegExp("([?&]".concat(key, "(?=[=&#]|$)[^#&]*|(?=#|$))")), newValueString).replace(/^([^?&]+)&/, '$1?');
    });

    _defineProperty(_assertThisInitialized(_this), "fillMenuWithResourceType", function (resourceTypes, emptyMenu) {
      if (!resourceTypes.length) return emptyMenu;
      var transformedResourceTypes = resourceTypes.map(function (_ref3) {
        var id = _ref3.id,
            name = _ref3.name;
        return {
          label: name,
          transformedName: id
        };
      });
      emptyMenu.push({
        label: 'Types of Resources',
        children: transformedResourceTypes
      });
      return emptyMenu;
    });

    _defineProperty(_assertThisInitialized(_this), "fillMenuWithAgeGroups", function (ageGroups, menuWithResourceTypes) {
      if (!ageGroups.length) return menuWithResourceTypes;

      var menu = _toConsumableArray(menuWithResourceTypes);

      var transformedAgeGroups = ageGroups.map(function (_ref4) {
        var stage = _ref4.stage,
            age = _ref4.age;
        return {
          label: age,
          transformedName: stage
        };
      });
      menu.push({
        label: 'Age Groups',
        children: transformedAgeGroups
      });
      return menu;
    });

    _defineProperty(_assertThisInitialized(_this), "isItSelection", function (checkedItems) {
      var filteredItems = checkedItems.filter(function (_ref5) {
        var ancestors = _ref5.ancestors;
        return ancestors[0].label === 'Types of Resources';
      });
      var allTheSame = filteredItems.length === 0 || filteredItems.length === checkedItems.length;
      return allTheSame;
    });

    _defineProperty(_assertThisInitialized(_this), "isLastItem", function (choosenTypes, choosenAges, checkedItems) {
      var valuesFromUrl = checkedItems[0].ancestors[0].label === 'Types of Resources' ? choosenTypes : choosenAges;
      return includes(valuesFromUrl, checkedItems[0].transformedName);
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(ElementsFiltersMobile, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          resourceTypes = _this$props.resourceTypes,
          ageGroups = _this$props.ageGroups,
          activeTypesOfResource = _this$props.activeTypesOfResource,
          activeStages = _this$props.activeStages;
      var choosenTypes = activeTypesOfResource && activeTypesOfResource.split(',');
      var choosenAges = activeStages.map(function (_ref6) {
        var stage = _ref6.stage;
        return stage;
      });
      var lastClickWasACheck = false;
      return /*#__PURE__*/React.createElement("div", {
        className: "elements__mobile-btn"
      }, /*#__PURE__*/React.createElement(SmartNav, {
        theme: "purple",
        menu: this.getMenu(resourceTypes, ageGroups),
        initialTitle: "Filters",
        resetAll: "All",
        itemKey: "transformedName",
        checkedItems: [].concat(_toConsumableArray(choosenTypes), _toConsumableArray(choosenAges)),
        onClickedItem: function onClickedItem(evt, item, isChecked) {
          lastClickWasACheck = isChecked === -1;
        },
        onDone: function onDone(checkedItems) {
          var currentUrl = window.location.href;

          if (!checkedItems || !checkedItems.length) {
            var urlResourceTypesUpdate = _this2.updateUrl(currentUrl, 'typeofresource', '');

            var _updatedUrl = _this2.updateUrl(urlResourceTypesUpdate, 'stage', '');

            return window.location.replace(_updatedUrl);
          }

          if (_this2.isItSelection(checkedItems)) {
            var isItAgeGroup = checkedItems[0].ancestors[0].label === 'Age Groups';

            if (!lastClickWasACheck) {
              var _urlParamKey = !isItAgeGroup ? 'stage' : 'typeofresource';

              var _newUrl = _this2.updateUrl(currentUrl, _urlParamKey, '');

              return window.location.replace(_newUrl);
            }

            var urlParamKey = isItAgeGroup ? 'stage' : 'typeofresource';
            var newUrlValues = checkedItems.map(function (_ref7) {
              var transformedName = _ref7.transformedName;
              return transformedName;
            }).join();

            var newUrl = _this2.updateUrl(currentUrl, urlParamKey, newUrlValues);

            return window.location.replace(newUrl);
          }

          var newResourceTypeValues = _this2.getNewValues(checkedItems, 'Types of Resources');

          var newStageValues = _this2.getNewValues(checkedItems, 'Age Groups');

          var urlUpdatedResourceTypes = _this2.updateUrl(currentUrl, 'typeofresource', newResourceTypeValues);

          var updatedUrl = _this2.updateUrl(urlUpdatedResourceTypes, 'stage', newStageValues);

          return window.location.replace(updatedUrl);
        }
      }));
    }
  }]);

  return ElementsFiltersMobile;
}(React.Component);

ElementsFiltersMobile.displayName = "ElementsFiltersMobile";

_defineProperty(ElementsFiltersMobile, "propTypes", {
  onHideModal: PropTypes.func.isRequired
});

ElementsFiltersMobile.propTypes = {
  resourceTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  ageGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeTypesOfResource: PropTypes.string,
  activeStages: PropTypes.arrayOf(PropTypes.object)
};
export default ElementsFiltersMobile;